/* @flow */

import PivotByCategoryAction from "../actions/PivotByCategoryAction";

import type {
    ClickAction,
    ClickActionProps
} from "platopulse/meta/types/Visualization";

export default (props: ClickActionProps): ClickAction[] => {
    return PivotByCategoryAction(props);
};



// WEBPACK FOOTER //
// ./qb/components/drill/PivotByCategoryDrill.jsx